// Wrappers de localStorage con try/catch. Motivo: en modo incógnito, en algunas WebViews y con
// storage lleno, cualquier acceso lanza. Nunca dejamos que la app crashe por eso: devolvemos
// el fallback o silenciamos el write.

export function persistGet<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function persistSet(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage lleno o bloqueado — ignoramos, no vale la pena mostrar al usuario.
  }
}

export function persistRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // idem
  }
}

// Para valores primitivos sueltos (p.ej. la clave de Google como string).
export function persistGetString(key: string, fallback = ""): string {
  try {
    return localStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}

export function persistSetString(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // idem
  }
}
